"use strict";
exports.__esModule = true;
function isDigit(c) {
    return !isNaN(parseInt(c));
}
exports.isDigit = isDigit;
function getDigitLength(value) {
    if (value === 0) {
        return 1;
    }
    return Math.floor(Math.log10(value)) + 1;
}
exports.getDigitLength = getDigitLength;
function isFixType(type) {
    return type[0] === 'f';
}
exports.isFixType = isFixType;
function rawString(value) {
    return value.toLocaleString('fullwide', { useGrouping: false });
}
exports.rawString = rawString;
//# sourceMappingURL=util.js.map